import { left, right } from "fp-ts/es6/Either";
import * as t from "io-ts";

import type { LocationState } from "../../app/state/route/RouteReducer";
import { type Match, matchPath } from "../../generic/routing";
import { type RouteResult, getOptionalSearchParam, unexpectedRouteError } from "../RouterUtils";

export const STACKPACKS_PATH = "/stackpacks";
export const STACKPACKS_INTEGRATION_PATH = "/stackpacks/:name/:integration";
export const STACKPACKS_STACKPACK_PATH = "/stackpacks/:name";

export interface StackPackNavigationParams {
	name: string;
	integration?: string;
	type?: StackPackType;
}

export type StackPackType = "Add-ons" | "Integrations";
export const StackPackType: t.Type<StackPackType> = t.union([t.literal("Add-ons"), t.literal("Integrations")]);

export interface StackPacksRouteParams {
	type?: StackPackType;
}

export function getStackPacksRouteParams(location: LocationState): RouteResult<StackPacksRouteParams> {
	return getStackPackTypeParam(location).map((type) => ({ type }));
}

export function getStackPackNavigationParams(location: LocationState): RouteResult<StackPackNavigationParams> {
	const result = matchStackPackPaths(location);
	if (!result?.params.name) {
		return left(unexpectedRouteError(STACKPACKS_INTEGRATION_PATH));
	}

	return getStackPackTypeParam(location).chain((type) =>
		right({
			name: result?.params.name,
			integration: result?.params.integration,
			type,
		}),
	);
}

const getStackPackTypeParam = (location: LocationState): RouteResult<StackPackType | undefined> =>
	getOptionalSearchParam(location, "type", StackPackType);

function matchStackPackPaths(location: LocationState): null | Match<StackPackNavigationParams> {
	const result = matchPath(location.pathname ?? "", { path: STACKPACKS_INTEGRATION_PATH });
	if (result?.params.name) {
		return result;
	}
	return matchPath(location.pathname ?? "", { path: STACKPACKS_STACKPACK_PATH });
}
